import React from "react";
import styled from "@emotion/styled";
import Shared03Divider from "../../../../guestsharedcomponents/Shared03Divider/Shared03Divider";

const ContainerDiv = styled.div`
  ${({ cardcss }) => `
    .course-image {
      background-image: url(${cardcss?.course_img});
    }
  `}
`;

const CardCourses = ({ options }) => {
  const { objinfo = {}, cardsRef, index, setActive, active } = options;

  const { content = {}, course_info = {} } = objinfo || {};
  const { course_img } = content || {};
  const { course_name, course_qty, course_description } = course_info || {};

  const isActive = index === active;

  const handleButtonClick = (e) => {
    if (!isActive) {
      e.preventDefault();
      setActive(index);
    }
  };

  return (
    <ContainerDiv
      className="card"
      ref={(el) => (cardsRef.current[index] = el)}
      onClick={() => setActive(index)}
      cardcss={{ course_img }}
    >
      <div className="course-image"></div>

      <Shared03Divider
        options={{
          obj_divider: {
            divider_mobile_styles: {
              width: "100%",
              background:
                "linear-gradient(90deg, transparent, #e6c28b, transparent)",
              margin: "0 auto",
            },
            divider_desktop_styles: false,
          },
          style_render: 992,
        }}
      />

      <div className="course-info t-flex-op1 t-ptb-1 t-plr-2">
        <span className="t-flex-ac">
          <i className="fa-brands fa-first-order-alt t-mr-1"></i>
          <span className="course-name">{course_name}</span>
        </span>
        <span className="qty">{course_qty} Lessons</span>
      </div>

      <Shared03Divider
        options={{
          obj_divider: {
            divider_mobile_styles: {
              width: "100%",
              background:
                "linear-gradient(90deg, transparent, #e6c28b, transparent)",
              margin: "0 auto",
            },
            divider_desktop_styles: false,
          },
          style_render: 992,
        }}
      />

      <p className="course-d">{course_description}</p>

      <a
        href="https://members.ltmastery.com/"
        className="course-btn t-flex-op4"
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleButtonClick}
      >
        Start Learning <i className="t-ml-1 fa-solid fa-arrow-right"></i>
      </a>
    </ContainerDiv>
  );
};

export default CardCourses;
